<template>
    <div>
        <h1>Office Payment</h1>
    </div>
</template>

<script>
    export default {
        name: 'OfficePayment'
    };
</script>
